define('modules/pagination/pagination_item_model',['backbone'], function(Backbone) {
  'use strict';
  var Item = Backbone.Model.extend({
    defaults: {
      id: 0,
      active: false,
      label: ''
    }
  });

  return Item;
});
